import {FC} from 'react'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {DAYS_OF_WEEK} from '@/features/users-availability/types'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Divider} from '@/components/ui/divider/Divider'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledTimeSlotRowContainer} from './style'

export const UserAvailabilitySkeletonView: FC = () => {
    return (
        <Grid columns={2} gap={1} fullWidth>
            {DAYS_OF_WEEK.map((day, index) => (
                <SkeletonDayRow key={day} isLast={index === DAYS_OF_WEEK.length - 1} />
            ))}
        </Grid>
    )
}

const SkeletonDayRow: FC<{isLast: boolean}> = ({isLast}) => {
    return (
        <>
            <GridItem spanColumn={2} gap={4}>
                <StyledTimeSlotRowContainer columns={2} gap={4}>
                    <GridItem spanColumn={1} gap={4}>
                        <Skeleton height={22} width={100} />
                    </GridItem>
                    <GridItem spanColumn={1} gap={4}>
                        <Flexbox direction="column" gap={2}>
                            <Skeleton height={20} width="70%" />
                        </Flexbox>
                    </GridItem>
                </StyledTimeSlotRowContainer>
            </GridItem>
            {!isLast && (
                <GridItem spanColumn={2}>
                    <Divider direction="horizontal" />
                </GridItem>
            )}
        </>
    )
}
